import { makeStyles } from 'tss-react/mui';

export const styles = makeStyles()(() => {
  return {
    container: {
      padding: "80px 0",
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1
    },
    message: {
      marginTop: "32px",
      marginBottom: "32px"
    }
  };
});
